document.addEventListener('DOMContentLoaded', () => {
    const submenus = document.querySelectorAll('.section-submenu');
    const mobileBreakpoint = window.matchMedia('(max-width: 48rem)');

    if (submenus.length === 0) {
        return;
    }

    submenus.forEach((submenu) => {
        const list = submenu.querySelector(':scope > .section-submenu__list');
        const activeLink = submenu.querySelector(':scope > .section-submenu__list > .section-submenu__item--active > .section-submenu__link-wrap > .section-submenu__link');

        if (list) {
            const mobileToggle = document.createElement('button');
            mobileToggle.type = 'button';
            mobileToggle.className = 'section-submenu__mobile-toggle';
            mobileToggle.setAttribute('aria-expanded', 'false');
            mobileToggle.innerHTML = `<span class="section-submenu__mobile-toggle-label">${activeLink?.textContent?.trim() || 'Podsekce'}</span><span class="section-submenu__mobile-toggle-icon" aria-hidden="true"></span>`;
            submenu.insertBefore(mobileToggle, list);

            mobileToggle.addEventListener('click', (event) => {
                if (!mobileBreakpoint.matches) {
                    return;
                }

                event.preventDefault();
                const willOpen = !submenu.classList.contains('is-mobile-open');
                submenu.classList.toggle('is-mobile-open', willOpen);
                mobileToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            });

            const syncMobileState = () => {
                if (!mobileBreakpoint.matches) {
                    submenu.classList.remove('is-mobile-open');
                    mobileToggle.setAttribute('aria-expanded', 'false');
                }
            };

            syncMobileState();
            mobileBreakpoint.addEventListener('change', syncMobileState);
        }

        submenu.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-section-submenu-toggle]');
            if (!toggle) {
                return;
            }

            const item = toggle.closest('.section-submenu__item');
            if (!item) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            const willOpen = !item.classList.contains('is-open');

            submenu.querySelectorAll('.section-submenu__item.is-open').forEach((otherItem) => {
                if (otherItem !== item) {
                    otherItem.classList.remove('is-open');
                    otherItem.querySelector('[data-section-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
                }
            });

            item.classList.toggle('is-open', willOpen);
            toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
    });

    document.addEventListener('click', (event) => {
        submenus.forEach((submenu) => {
            if (submenu.contains(event.target)) {
                return;
            }

            submenu.classList.remove('is-mobile-open');
            submenu.querySelector('.section-submenu__mobile-toggle')?.setAttribute('aria-expanded', 'false');

            submenu.querySelectorAll('.section-submenu__item.is-open').forEach((item) => {
                item.classList.remove('is-open');
                item.querySelector('[data-section-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
            });
        });
    });
});
